$('#questions').on('show.bs.collapse', function (e) {
    $('#questions .collapse.show, .mobile-questions .collapse.show').not(e.target).collapse('hide')
})

// Show correct question based on hash tag in URL.
$(document).ready(function() {
    if(window.location.hash) {
        let questionId = window.location.hash.replace('#', '');
        $('button[data-question_id="' + questionId + '"]').click();
        $('.collapse').removeClass('show');
        $('button[data-question_id="' + questionId + '"]').parents('.collapse').addClass('show');
    }
});
